module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/LV-6d3b16492d9ebb1bd44aead6a1c6bb83.png";